import { Component, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-audit-formula",
  templateUrl: "./audit-formula.component.html",
  styleUrls: ["./audit-formula.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AuditFormulaComponent implements OnInit {
  ngOnInit() {
    // not doing anithing
  }
}
